module.exports = __webpack_public_path__ + "img/tile-onionskins-desktop_en.85ea685.jpg";